import { ApolloClient, InMemoryCache } from '@apollo/client'

import { authLink } from './apolloClientLinks'

const cache = new InMemoryCache()

export const client = new ApolloClient({
  cache,
  link: authLink,
})
